import { Box, Paper, Tooltip, Typography } from "@mui/material";
import { GridColDef, GridEventListener } from "@mui/x-data-grid";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { DNI_TYPE } from "../../../assets/constants/translates";
import { BaseDataGrid } from "../../../components/BaseDataGrid";
import { convertToDate } from "../../../helpers/dateFormat";
import endpoints from "../../../helpers/endpoints";
import { toNameFormat } from "../../../helpers/functions";
import useAxios from "../../../hooks/useAxios";
import { PaginatedResponse } from "../../../types/Pagination";
import { PersonType } from "../../../types/Person";

let columns: GridColDef[] = [
  {
    field: "id",
    headerName: "ID",
    description: "Código de solicitud",
    width: 60,
  },
  {
    field: "name",
    headerName: "Nombre",
    description: "Nombre del ciudadano",
    minWidth: 100,
    flex: 40,
    renderCell: (params: { row: PersonType }) => {
      return <>{toNameFormat(params.row.name)}</>;
    },
  },
  {
    field: "lastName",
    headerName: "Apellido",
    description: "Apellidos del ciudadano",
    minWidth: 100,
    flex: 40,
    renderCell: (params: { row: PersonType }) => {
      return <>{toNameFormat(params.row.lastName)}</>;
    },
  },
  {
    field: "dni",
    headerName: "DNI",
    description: "Tipo y número de documento",
    minWidth: 100,
    flex: 10,
    renderCell: (params: { row: PersonType }) => {
      const { dniType, dni } = params.row as PersonType;
      return (
        <Tooltip title={DNI_TYPE.find((value) => value.value === dniType)?.text as string}>
          <span>{dni}</span>
        </Tooltip>
      );
    },
  },
  {
    field: "phoneNumber",
    headerName: "Celular",
    description: "Número de celular",
    minWidth: 100,
    flex: 10,
  },
  {
    field: "createdAt",
    headerName: "Creado",
    description: "Fecha de creación",
    width: 100,
    align: "center",
    headerAlign: "center",
    valueGetter: (value) => new Date(value),
    renderCell: (params: { row: PersonType }) => {
      const [date, hour] = convertToDate(params.row.createdAt);
      return (
        <Tooltip title={hour}>
          <span>{date}</span>
        </Tooltip>
      );
    },
  },
];

export const People = () => {
  let navigate = useNavigate();
  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 25 });

  const { data: personsResponse, loading: loadingPersons } = useAxios<PaginatedResponse<PersonType> | PersonType[]>({
    url: `${endpoints.getPersons}?page=${paginationModel.page + 1}&limit=${paginationModel.pageSize}`,
    initialData: [],
  });

  const persons = Array.isArray(personsResponse) ? personsResponse : personsResponse?.data || [];
  const totalPersons = Array.isArray(personsResponse) ? personsResponse.length : personsResponse?.meta?.total || 0;

  const handleRowClick: GridEventListener<"rowClick"> = (params) => {
    navigate("../ciudadano/" + params.row.id);
  };

  return (
    <Box width="100%">
      <Typography variant="h3">Ciudadanos registrados</Typography>
      <Paper sx={{ width: "100%" }} elevation={3}>
        <BaseDataGrid
          rows={persons}
          columns={columns}
          loading={loadingPersons}
          paginationMode="server"
          rowCount={totalPersons}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          onRowClick={handleRowClick}
        />
      </Paper>
    </Box>
  );
};
